var taricCertificate = angular.module('taric.certificate', ['taric.certificate.lookup']);
taricCertificate.config(function ($stateProvider) {
    $stateProvider.state('taric.certificate', {
        abstract: true,
        url: '/certificate',
        template: '<ui-view></ui-view>'
    }).state('taric.certificate.lookup', {
        url: '/lookup?frm&sd&ce',
        templateUrl: 'taric/certificate/lookup/certificate-lookup.tmpl.html',
        controller : 'CertificateLookupController as certificateLookupCtrl',
        resolve: {
            initializeSearchCriteria: function(CertificateLookupModel, $stateParams, CommonHelper){
                CertificateLookupModel.resetSearchCriteria();
                CertificateLookupModel.resetSearchResult();

                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        CertificateLookupModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.ce && $stateParams.ce.length === 4){
                    CertificateLookupModel.getSearchCriteria().certificateType = $stateParams.ce.substr(0,1);
                    CertificateLookupModel.getSearchCriteria().certificateId = $stateParams.ce.substr(1,3);
                }
            },
            certificateTypes: function(CertificateTypeModel){
                return CertificateTypeModel.queryCertificateTypes();
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/certificate');
            },
            setupMenu: function (MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }
        }
    });
});


// WEBPACK FOOTER //
// ./app/taric/certificate/taric-certificate.js